module.exports = __webpack_public_path__ + "static/media/spencer-davis-ps8zSj_hqjU-unsplash.883808ea.jpg";